import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core'
import { MatIconModule } from '@angular/material/icon'

/** The small square button with a chevron that collapses or expands a panel. Its position stays in the parent. */
@Component({
  selector: 'button[wm-front-collapse-button]', // eslint-disable-line
  templateUrl: './collapse-button.component.html',
  styleUrls: ['./collapse-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule],
})
export class CollapseButtonComponent {
  /** Whether the panel is collapsed: the chevron then points the other way */
  @HostBinding('class.collapsed')
  @Input()
  public collapsed: boolean | null = false

  @HostBinding('attr.type')
  public readonly type = 'button'
}
